import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { InfoBarViewStates } from 'owa-calendar-info-bar/lib/utils/allViewStates';
import {
    isSeriesMaster,
    isSeriesInstance,
    isFTDFSeriesMaster,
} from 'owa-calendar-event-capabilities';

/**
 * Returns the InfoBar to indicate whether editing the master or occurrence for a recurring event
 * @param originalEvent
 */

export default (originalEvent: CalendarEvent): InfoBarMessageViewState[] => {
    if (
        originalEvent.ItemId /* If ItemId is null (compose scenario not edit), then don't show the infobar */ &&
        isSeriesMaster(originalEvent)
    ) {
        return [InfoBarViewStates.getInfoEditingMasterOfSeries()];
    } else if (
        originalEvent.ItemId /* If ItemId is null (compose scenario not edit), then don't show the infobar */ &&
        isFTDFSeriesMaster(originalEvent)
    ) {
        return [InfoBarViewStates.getInfoEditingFromThisDayMasterOfSeries()];
    } else if (
        originalEvent.ItemId /* If ItemId is null (compose scenario not edit), then don't show the infobar */ &&
        isSeriesInstance(originalEvent)
    ) {
        return [InfoBarViewStates.getInfoEditingOccurrenceOfSeries()];
    }

    return [];
};
